import { TableCell, TableHead, TableRow, TableSortLabel } from "@material-ui/core";

const OccmHd = ({ sort, sort_by, createSortHandler }) => {
	const sortLabel = (key, name) => (
		<TableSortLabel
			active={sort === key}
			direction={sort === key ? sort_by : 'asc'}
			onClick={() => createSortHandler(key)}
		>
			{name}
		</TableSortLabel>
	);

	return (
		<TableHead className="engine-module-table">
			<TableRow>
				<TableCell style={{ minWidth: '140px' }}>Action(s)</TableCell>
				<TableCell style={{ minWidth: '130px' }}>{sortLabel('ata_chapter', 'ATA Chapter')}</TableCell>
				<TableCell style={{ minWidth: '220px' }}>{sortLabel('part_description', 'Part Description')}</TableCell>
				<TableCell style={{ minWidth: '140px' }}>{sortLabel('part_number', 'Part Number')}</TableCell>
				<TableCell style={{ minWidth: '160px' }}>{sortLabel('part_serial_number', 'Part Serial Number')}</TableCell>
				<TableCell style={{ minWidth: '170px' }}>{sortLabel('part_installation_date', 'Part Installation Date')}</TableCell>
				<TableCell style={{ minWidth: '190px' }}>{sortLabel('aircraft_tsn', 'Aircraft TSN at Installation')}</TableCell>
				<TableCell style={{ minWidth: '190px' }}>{sortLabel('aircraft_csn', 'Aircraft CSN at Installation')}</TableCell>
				<TableCell style={{ minWidth: '170px' }}>{sortLabel('part_tsn', 'Part TSN at Installation')}</TableCell>
				<TableCell style={{ minWidth: '170px' }}>{sortLabel('part_csn', 'Part CSN at Installation')}</TableCell>
				<TableCell style={{ minWidth: '160px' }}>{sortLabel('occm_requirement', 'OCCM Requirement')}</TableCell>
				<TableCell style={{ minWidth: '220px' }}>{sortLabel('remark', 'Remarks')}</TableCell>
				<TableCell style={{ minWidth: '110px' }}>Attachments</TableCell>
			</TableRow>
		</TableHead>
	);
};

export default OccmHd;
